import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-desktop',
  templateUrl: './desktop.component.html',
  styleUrls: ['./desktop.component.scss'],
})
export class ConfirmationDesktopComponent {
  @Output() download = new EventEmitter();

  @Input() supplier: any;

  @Input() pickupPoint: any;

  @Input() dropoff: any;

  @Input() waybillDetails: any;

  @Input() waybillValidation: any;

  @Input() pickupAddress: any;

  @Input() waybillType: any;
}
